import React from 'react';
import PropTypes from 'prop-types';
import SearchListItemLink from './item_link';
import SearchListItemFigure from './item_figure';
import SearchListItemTitle from './item_title';
import SearchListItemSubTitle from './item_subtitle';

const SearchListItem = props => (
  <li className="afd-search-list__item myad-search-list__item slide js_slide">
    <SearchListItemLink link={props.link}>
      <SearchListItemFigure backgroundImage={props.backgroundImage} />
      <SearchListItemTitle title={props.title} />
      <SearchListItemSubTitle subtitle={props.subtitle} />
    </SearchListItemLink>
    {props.children}
  </li>
);

SearchListItem.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string.isRequired,
  link: PropTypes.string.isRequired,
  backgroundImage: PropTypes.string.isRequired,
  children: PropTypes.node,
};

SearchListItem.defaultProps = {
  children: null,
};

export default SearchListItem;
